<template>
  <el-container id="advice">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} > </p>
        <p style="color:#000000;line-height:0.3;margin-left:5px">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-main style="background:#FFFFFF;padding:10px;">
        <div style="display:flex;height:100px;width:100%;margin-top:0px">
          <div style="display:flex;width:33%;background-color:#F4F4F4">
            <div style="width:90px;margin:20px">
              <p style="margin: 0;color: #6B7280">未处理反馈</p>
              <p style="font-weight:bold;margin-top:0;margin-left:3px">{{ noProcess }}</p>
            </div>
            <!--            <el-image style="width:25px;height:20px;margin-left:auto;margin-right:20px;margin-top:36px"-->
            <!--                      :src="notice_gg"-->
            <!--                      fit="fit">-->
            <!--            </el-image>-->
          </div>
          <div style="display:flex;width:34%;margin-left:5px;background-color:#F4F4F4">
            <div style="width:90px;margin:20px">
              <p style="margin:0;color: #6B7280">已处理反馈</p>
              <p style="font-weight:bold;margin-top:0;margin-left:3px">{{ hasProcess }}</p>
            </div>
            <!--            <el-image style="width:25px;height:20px;margin-left:auto;margin-right:20px;margin-top:36px"-->
            <!--                      :src="notice_lj"-->
            <!--                      fit="fit">-->
            <!--            </el-image>-->
          </div>
          <div style="display:flex;width:33%;margin-left:5px;margin-right:0px;background-color:#F4F4F4">
            <div style="width:90px;margin:20px">
              <p style="margin: 0;color: #6B7280">今日新增</p>
              <p style="font-weight:bold;margin-top:0;margin-left:3px">{{ todayNew }}</p>
            </div>
            <!--            <el-image style="width:25px;height:20px;margin-left:auto;margin-right:20px;margin-top:36px"-->
            <!--                      :src="notice_day"-->
            <!--                      fit="fit">-->
            <!--            </el-image>-->
          </div>
        </div>
        <div style="width:90%;padding-left:1vh;margin-left:5px;background-color: #FFFFFF">
          <p>反馈类型占比
            <el-radio-group v-model="but_zb" style="margin-left:5px" @change="getFeedbackStatis(false)">
              <el-radio-button label="今日"></el-radio-button>
              <el-radio-button label="本周"></el-radio-button>
              <el-radio-button label="本月"></el-radio-button>
            </el-radio-group>
            <el-date-picker
                v-model="ediTypeTime"
                type="daterange"
                :clearable="false"
                @change="getFeedbackStatis(true)"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </p>
          <div style="height: 20vh">
            <div id="myChart1" style="width:100%; height:100%;margin-bottom:0px"> <!--饼状图-->
            </div>
          </div>
        </div>
        <div
            style="display:flex;height:40px;margin-top:5px;width:100%;line-height:0.3;text-align:left;align-items: center;">
          <el-date-picker
              v-model="ediTime"
              type="daterange"
              @change="getAdvice()"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
          <span style="margin-left:5px; font-size: 13px">
            <el-input
                placeholder="搜索反馈内容"
                style="width:15vw;"
                prefix-icon="el-icon-search"
                clearable
                @change="getAdvice()"
                v-model="ediTitle">
            </el-input>
          </span>
          <el-select v-model="edi_type" ref='devSonSelect'
                     @change="getAdvice"
                     clearable filterable placeholder="反馈类型"
                     style="width:8vw;margin-left:5px">
            <el-option
                v-for="item in li_type"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="edi_state" ref='devSonSelect'
                     @change="getAdvice"
                     clearable filterable placeholder="回复状态"
                     style="width:8vw;margin-left:5px">
            <el-option
                v-for="item in li_state"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-button style="margin-left:10px;height:40px;" type="primary" @click="onResh" icon="el-icon-refresh">
            重置
          </el-button>
        </div>
        <el-table :data=fil_tabData ref="table" class="tab_adb" :cell-style="tableYs"
                  style="width:100%; font-size:13px; background:#FFFFFF;margin-top:5px"
                  show-overflow-tooltip
                  :header-cell-style="{'height':'30px','text-align':'center','background':'#F4F4F4','color':'#0dA7C8'}">
          <el-table-column width="01" sortable/>
          <div v-for="(d,item) in this.defHead">
            <el-table-column :key=item :prop=d.val :label=d.key :width="d.w">
            </el-table-column>
          </div>
          <el-table-column
              label="操作"
              width="200">
            <template slot-scope="scope">
              <el-button @click="onChangeAdvice(scope.row,'r')" type="text" size="small"
                         style="color:#4B5563;font-size: 14px">查看
              </el-button>
              <el-button @click="onChangeAdvice(scope.row,'w')" type="text" size="small"
                         style="color:#1677FF;font-size: 14px">回复
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="float:right; margin-right:0.5vw;margin-top:5px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange1"
            :current-page="page"
            :page-sizes="[10,20,30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </el-main>
      <el-footer style="background-color:#F4F4F4;height:1px;margin-bottom:10px;padding:0"></el-footer>
    </el-container>
    <el-dialog
        title="删除提示"
        :visible.sync="daiDelNotice"
        width="30%">
      <span>确定删除该意见吗？ 删除后将无法找回，请谨慎操作</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="daiDelNotice = false">取 消</el-button>
        <el-button type="primary" @click=delUser()>确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import Sortable from 'sortablejs';

export default {
  name:"advice",
  components:{ /*引入组件*/

  },
  data() {
    return {
      h_text:"意见反馈管理",
      li_h_text:[
        {"text":"会所管理","colour":"#B7B7B7","pages":""}
      ],
      notice_lj:require('@/assets/notice_lj.png'),
      notice_day:require('@/assets/notice_day.png'),
      notice_gg:require('@/assets/notice_gg.png'),
      scan_user:"",
      ediTime:"",
      tabData:[],
      maxHeight:window.innerHeight - 350,
      defHead:[
        {'key':"反馈Id",'val':"id","w":"auto"},
        {'key':"用户名",'val':"name","w":"auto"},
        {'key':"反馈类型",'val':"feedType","w":"auto"},
        {'key':"反馈内容",'val':"description","w":"auto"},
        {'key':"反馈时间",'val':"times1","w":"auto"},
        {'key':"状态",'val':"state","w":"auto"}
      ],
      page:1,
      pageSize:10,
      total:0,
      noProcess:0,
      hasProcess:0,
      todayNew:0,
      ediTitle:"",
      li_advice:[],
      daiDelNotice:false,
      but_zb:"本月",
      zb_list:[],
      ediTypeTime:"",
      edi_state:"",
      li_state:[
        {label:"待处理",value:1},
        {label:"已回复",value:2}
      ],
      edi_type:"",
      li_type:[
        {label:"功能建议",value:1},
        {label:"投诉建议",value:2},
        {label:"服务体验",value:3},
        {label:"其他",value:4}
      ]
    };
  },
  methods:{ /*方法存放*/
    tableYs({row,column,rowIndex,columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282';
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getAdvice();
    },
    handleCurrentChange1(val) {
      this.page = val;
      this.getAdvice();
    },
    onResh() {
      this.edi_type = "";
      this.ediTime = "";
      this.ediTitle = "";
      this.edi_state = "";
      this.getAdvice();
    },
    onAddNotice() {
      this.$router.push({ /*路由跳转传值*/
        path:'/home/hsAdviceSon',
        query:{key:'addNotice'}
      });
    },
    onChangeAdvice(row,operate) {
      this.$router.push({ /*路由跳转传值*/
        path:'/home/hsAdviceSon',
        query:{
          key:'changeNotice',
          id:row.id,
          operate:operate
        }
      });
    },
    getAdvice() {
      const params = {
        'page':this.page,
        'pageSize':this.pageSize,
        'projectId':localStorage.getItem("projectId")
      };
      if (this.ediTitle) {
        params["description"] = this.ediTitle; /*反馈内容*/
      }
      if (this.edi_type) {
        params["feedType"] = this.edi_type; /*反馈类型*/
      }
      if (this.edi_state) {
        params["stateId"] = this.edi_state; /*回复状态*/
      }
      if (this.ediTime) {
        console.log(new Date().getTime());
        console.log(this.ediTime[0].getTime() / 1000); /*筛选时间*/
        console.log(this.ediTime[1].getTime() / 1000); /*筛选时间*/
        params['startTime'] = parseInt("" + this.ediTime[0].getTime() / 1000);
        params['endTIme'] = parseInt(this.ediTime[1].getTime() / 1000) + 86400; /*结尾+1天*/
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getFeedbackList,params,headers).then(res => {
        console.log("getFeedbackList：",res.data.data);
        this.li_advice = res.data.data["list"];
        this.total = res.data.data.total;
        if (this.total > 0) {
          this.init_View();
        } else {
          this.tabData = [];
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取意见数据失败");
        }
      });
    },
    getFeedbackStatis(isTime) {
      const params = {
        'projectId':localStorage.getItem("projectId")
      };
      if (isTime) {
        this.but_zb = "其他";
        if (this.ediTypeTime) {
          params["type"] = 4;
          params['startTime'] = parseInt("" + this.ediTypeTime[0].getTime() / 1000);
          params['endTIme'] = parseInt("" + this.ediTypeTime[1].getTime() / 1000) + 86400; /*结尾+1天*/
        }
      } else {
        this.ediTypeTime = "";
        if (this.but_zb === "今日") {
          params["type"] = 1;
        } else if (this.but_zb === "本周") {
          params["type"] = 2;
        } else if (this.but_zb === "本月") {
          params["type"] = 3;
        }
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getFeedbackStatis,params,headers).then(res => {
        console.log("getFeedbackStatis：",res.data.data);
        this.noProcess = res.data.data["noProcess"];
        this.hasProcess = res.data.data["hasProcess"];
        this.todayNew = res.data.data["todayNew"];
        if (res.data.data["items"]) {
          let li_d = res.data.data["items"];
          if (li_d.length > 0) {
            let l_zb = [];
            for (let i = 0; i < li_d.length; i++) {
              let d = {
                value:li_d[i]["percent"],
                name:"",
                itemStyle:{
                  color:'#' + Math.floor(Math.random() * 16777215).toString(16)
                }
              };
              switch (li_d[i]["feedType"]) {
                case 1:
                  d.name = "功能建议";
                  break;
                case 2:
                  d.name = "投诉建议";
                  break;
                case 3:
                  d.name = "服务体验";
                  break;
                default:
                  d.name = "其他建议";
                  break;
              }
              l_zb.push(d);
            }
            this.zb_list = l_zb;
          } else {
            this.zb_list = [];
          }
        } else {
          this.zb_list = [];
        }
        this.drawLine1();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取反馈意见类型失败");
        }
      });
    },
    upState(row,stateId) {
      const params = {
        'id':row.id,
        'stateId':stateId,  /*1 -"未发布", 2 - 已发布, 3 -已取消 4-已过期*/
        'pubTime':parseInt("" + new Date().getTime() / 1000),
        'sysUserId':localStorage.getItem("userId"),
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.updateNotify,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("修改成功");
        this.getAdvice();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("修改失败");
        }
      });
    },
    onDelNotice(row) {
      this.id = row.id;
      this.daiDelNotice = true;
    },
    delUser() {
      const params = {
        'id':this.id,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.delNotify,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("删除成功");
        this.daiDelNotice = false;
        if (this.total % this.pageSize === 1 && this.page !== 1) {
          this.page -= 1;
        }
        this.getAdvice();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("删除失败");
        }
      });
    },
    drawLine1() {
      let myChart1 = this.$echarts.getInstanceByDom(
          document.getElementById('myChart1')
      );
      if (myChart1 == null) {  /*基于准备好的dom，初始化echarts实例*/
        this.myChart1 = this.$echarts.init(document.getElementById('myChart1'));
      } else {
        this.myChart1.clear();
      }
      this.myChart1.setOption({ /*绘制图表*/
        series:[
          {
            name:"", /*['女', '男']*/
            type:'pie',    // 设置图表类型为饼图
            radius:'66%',  // 饼图的半径，外半径为可视区尺寸（容器高宽中较小一项）的 66% 长kWh。
            data:this.zb_list,          // 数据数组，name 为数据项名称，value 为数据项值
            label:{ /*position:"", //标签的位置*/
              formatter:'{b}：{c}%',
              fontWeight:'normal',
              fontSize:13,
              color:this.bj_dev_txt,
              textStyle:{
                fontWeight:'bold' // 设置柱状图顶部的标签加粗
              }
            }
          }
        ]
      });
    },
    timestampToTime(timestamp) {/*秒转时间*/
      let date = new Date(timestamp);
      let Y = date.getFullYear() + '-';
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1):(date.getMonth() + 1)) + '-';
      let D = (date.getDate() < 10 ? '0' + date.getDate():date.getDate()) + ' ';
      let h = (date.getHours() < 10 ? '0' + date.getHours():date.getHours()) + ':';
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes():date.getMinutes()) + ':';
      let s = (date.getSeconds() < 10 ? '0' + date.getSeconds():date.getSeconds());
      return Y + M + D + h + m + s;
    },
    init_View() {
      let data = this.li_advice;
      let li_d = [];
      for (let i = 0; i < data.length; i++) {
        let d = {
          id:data[i]['id'],
          name:data[i]['name'],
          feedType:data[i]['feedType'],
          detail:data[i]['detail'], /*用户反馈*/
          description:data[i]['description'], /*反馈内容*/
          times1:this.timestampToTime(data[i]['feedbackTime'] * 1000),
          stateId:data[i]['stateId'],
          state:""
        };
        switch (data[i].feedType) {
          case 1:
            d.feedType = "功能建议";
            break;
          case 2:
            d.feedType = "投诉建议";
            break;
          case 3:
            d.feedType = "服务体验";
            break;
          default:
            d.feedType = "其他";
            break;
        }
        switch (data[i].stateId) {
          case 1:
            d.state = "待处理"; /*已反馈*/
            break;
          case 2:
            d.state = "已回复";
            break;
          default:
            d.state = "待处理";
            break;
        }
        li_d.push(d);
      }
      this.tabData = li_d;
    }
  },
  mounted() { /*页面加载时调用*/
    this.getAdvice();
    this.getFeedbackStatis(false);
  },
  beforeDestroy() { /*页面结束时调用*/

  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    fil_tabData() {
      return this.tabData.filter(item => {
        this.state = true;
        // if (this.edi_auth && item.authorityId !== this.edi_auth) {
        //   this.state = false
        // }
        // if (this.scan_user && !item.userName.includes(this.scan_user)) {
        //   this.state = false
        // }
        // if (this.edi_status) {
        //   if (this.edi_status.includes("启用")) {
        //     if (!item.userState) {
        //       this.state = false
        //     }
        //   } else {
        //     if (item.userState) {
        //       this.state = false
        //     }
        //   }
        // }
        return this.state;
      });
    }
  },
  watch:{  /*监听参数变化*/

  }
};
</script>

<style>

#advice {
  height: 100vh;
  margin: 0;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #FFFFFF;
  height: auto;
  margin-bottom: 60px;
  border-radius: 5px 5px 5px 5px;
  overflow-y: auto;
}

.tab_adb {
  user-select: text;

  .gutter { /*去除表格右边留白*/
    background-color: #FFFFFF !important;
    border: 5px solid #FFFFFF !important;
  }

  .el-table__header-wrapper {
    .el-table__header {
    }
  }

  .el-table__body-wrapper {
    background: #FFFFFF;
    height: calc(100% - 66px) !important; /*去除表格底部留白*/
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #0dA7C8;
  }

  ::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #cacaca;
    border: 1px solid #cacaca;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/hs/advice.vue